module.exports = __webpack_public_path__ + "img/copy-pay-hero.debdd45c.png";